import instance from '@/composables/axios';
import instanceNew from '@/composables/axiosNew';

const URL = process.env.VUE_APP_URL_EMPLOYEE_SERVICE + 'employee';
class HRService {
  async add(dto) {
    const response = await instance(URL).post('', dto, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  }

  async updateProfile(dto) {
    const response = await instance(URL).post('/profile', dto, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  }

  async updateTeam(employeeId, dto) {
    const pathVariable = `/team/${employeeId}`;
    const response = await instance(URL).put(pathVariable, dto);
    return response;
  }

  async page(params, isNotDefault) {
    if (!isNotDefault) {
      params = params ? { ...params, usedYn: 'Y' } : (params = { usedYn: 'Y' });
      params = { ...params, stat: `WORKING,ABSENCE` };
    }
    const response = await instance(URL).get('', { params });
    return response;
  }

  async pageSecure(params, isNotDefault) {
    if (!isNotDefault) {
      params = params ? { ...params, usedYn: 'Y' } : (params = { usedYn: 'Y' });
      params = { ...params, stat: `WORKING,ABSENCE` };
    }
    const response = await instance(URL).get('/secure', { params });
    return response;
  }

  async pageWithProfileImage(params, isNotDefault) {
    // if (!isNotDefault) {
    //   params = params ? { ...params, usedYn: "Y"} : params = { usedYn: "Y"};
    //   params = { ...params, stat: `WORKING,ABSENCE` };
    // }
    const response = await instance(URL).get('/profile', { params });
    return response;
  }

  async pageSecureNew(params, callbacks) {
    const response = await instanceNew(URL, callbacks).get('/secure', {
      params,
    });
    return response;
  }

  async pageLeft(params, callbacks) {
    const response = await instanceNew(URL, callbacks).get('/left', { params });
    return response;
  }

  async callMealCostEmployee(params) {
    params = { stat: 'WORKING', usedYn: 'Y', sort: 'nameKr', order: 'ASC' };
    return await instance(URL).get('', { params });
  }

  async getOne(employeeId) {
    const response = await instance(URL).get(`/${employeeId}`);
    return response;
  }

  async getOneNew(employeeId, callbacks) {
    const response = await instanceNew(URL, callbacks).get(`/${employeeId}`);
    return response;
  }

  async getImg() {
    return await instance(URL).get('/img');
  }

  async getCeo() {
    const response = await instance(URL).get();
    return response;
  }

  async checkDuplicate(email) {
    const response = await instance(URL).get('duplicate/' + email);
    return response;
  }

  async checkDuplicateNew(email, callbacks) {
    const response = await instanceNew(URL, callbacks).get(`duplicate/${email}`);
    return response;
  }

  async delete(id, callbacks) {
    const response = await instanceNew(URL, callbacks).delete(`/${id}`);
    return response;
  }

  async checkPassInit(callbacks) {
    const response = await instanceNew(URL, callbacks).get('/checkPassInit');
    return response;
  }

  selectLabeling(dataList, key, parameterKey, addKeyList) {
    let list = [];
    if (dataList.length > 0) {
      list = dataList.map((data) => {
        let row = {};
        row = {
          key,
          id: data.employeeId,
          label: data[key],
          value: data[key],
          parameterKey,
          parameterValue: data[key],
        };
        if (addKeyList) {
          addKeyList.forEach((customKey) => (row[customKey] = data[customKey]));
        }
        return row;
      });
    }
    return list;
  }

  // selectLabeling (dataList, key, parameterKey, addKeyList) {
  //   if (dataList.length > 0) {
  //     return dataList.map(data => {
  //       return {
  //         key,
  //         id: data.employeeId,
  //         label: data[key],
  //         value: data[key],
  //         parameterKey,
  //         parameterValue: data[key]
  //       }
  //     })
  //   }
  // }
}

export default new HRService();
